// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"c6a59b01","147":"1188746b","357":"746bac77","453":"d456ce70","577":"d8445755","708":"1ea81c9b","843":"759c8c43"}[chunkId] + ".chunk.js";
};